import React from 'react';
import PropTypes from 'prop-types';

import { lightGray, charcoal, lighterGray } from 'lib/v2/colors';

// material-core
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import MuiBox from '@mui/material/Box';
import Button from './Button';

// matches form width from: components/v2/FormElements/index.js
const MAX_WIDTH = '45rem';

const Spacer = styled(MuiBox)({
  height: '3.5rem',
});

const Container = styled(MuiBox)({
  display: 'flex',
  position: 'fixed',
  justifyContent: 'space-between',
  bottom: 0,
  left: '18rem',
  right: '6rem',
  maxWidth: MAX_WIDTH,
  padding: '1rem',
  background: lighterGray,
  border: '1px solid',
  borderBottom: 'none',
  borderColor: lightGray,
  borderRadius: '5px 5px 0 0',
  boxShadow: '0px 10px 8px rgba(0, 0, 0, 0.25)',
  zIndex: 999,
});

const Message = styled(Typography)({
  color: charcoal,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

const Buttons = styled(MuiBox)({
  display: 'flex',
  justifyContent: 'flex-end',
  '& button': {
    marginLeft: '1rem',
  },
});

const SubmitButton = styled(Button)({
  padding: '0 2rem',
});

const CancelButton = styled(Button)({
  color: charcoal,
});

const SavePrompt = ({
  disabled = false,
  onCancel,
  onClick,
  cancelText = 'Cancel',
  loading = false,
  clickText = 'Save',
  sidebar = false,
  ...rest
}) => {
  return (
    <>
      {!sidebar && <Spacer />}
      <Container>
        <Message variant="body1">You have unsaved changes</Message>

        <Buttons>
          <CancelButton type="button" variant="text" onClick={onCancel || onClick}>
            {cancelText}
          </CancelButton>

          <SubmitButton
            disabled={disabled || loading}
            variant="contained"
            color="primary"
            loading={loading}
            onClick={onClick}
          >
            {clickText}
          </SubmitButton>
        </Buttons>
      </Container>
    </>
  );
};

SavePrompt.propTypes = {
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  clickText: PropTypes.string,
  cancelText: PropTypes.string,
  disabled: PropTypes.bool,
};

export default SavePrompt;
